import React, { FC, useEffect, useState } from 'react';
import { destroyStack, getStacks } from '../api/requests';
import styled from '@emotion/styled';
import { Trash } from '@emotion-icons/ionicons-outline/Trash';
import { useNavigate } from 'react-router-dom';
import { useAuthUser } from '../containers/AuthProvider';
import { extractStackShortId } from '../api/utils/utils';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  padding: 1rem;
`;

const CircleButton = styled.button`
  background-color: ${(props) => props.color};
  border-radius: 2rem;
  border: 0;
  padding: 0.5rem;
  color: white;
  cursor: pointer;
`;

const Item = styled.div`
  border: 0.25rem solid gray;
  border-radius: 0.5rem;
  word-wrap: break-word;
  width: 200px;
  height: 200px;
  padding: 1rem;
  color: black;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const StacksPage: FC = () => {
  const user = useAuthUser();
  const navigate = useNavigate();
  const [stacks, setStacks] = useState<any>();

  useEffect(() => {
    const fetchData = async () => {
      const newStacks = await getStacks();
      setStacks(newStacks);
    };

    fetchData().catch(console.error);
  }, []);

  const handleDestroyStack = (stackName: string) => async () => {
    const stackId = extractStackShortId(stackName);
    await destroyStack(stackId, user?.email || 'web-actor-not-defined');
    navigate('/');
  };

  return <Container>
    {stacks && stacks.map(stack => <Item key={stack.name}>
      {stack.name}
      <CircleButton color='red' onClick={handleDestroyStack(stack.name)}><Trash size={24}/></CircleButton>
    </Item>)}
  </Container>;
};
